import { Button, CustomTooltip, IOnboardingTooltipProps, UIText2 } from '@cian/ui-kit';
import { plural } from '@cian/utils';
import * as React from 'react';

import * as styles from './SearchResultsTooltip.css';
import { useSearchTooltipContext } from '../../../../containers/FiltersContainer';
import * as ReactDOM from 'react-dom';
import { useForkRef } from '@cian/react-utils';

interface ISearchResultsTooltipProps extends Pick<IOnboardingTooltipProps, 'open' | 'placement' | 'children'> {
  hostElement?: HTMLElement | null;
  onApply?(): void;
}

export const SearchResultsTooltip: React.FC<ISearchResultsTooltipProps> = props => {
  const { children, placement, hostElement, open } = props;
  const { offersCount, loading, onApply } = useSearchTooltipContext();
  const text = `Найдено ${offersCount} ${plural(offersCount, ['проект', 'проекта', 'проектов'])}`;

  const childrenRef = React.useRef<HTMLElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChildrenRef = useForkRef((children as any).ref, childrenRef);

  const handleApply = React.useCallback(() => {
    onApply();

    if (props.onApply) {
      props.onApply();
    }
  }, [onApply, props]);

  const tooltipElement = (
    <CustomTooltip
      anchorRef={childrenRef}
      arrow
      flip
      preventOverflow
      minHeight={56}
      maxWidth={320}
      theme="black"
      placement={placement}
      portal={false}
      content={
        <div data-name="SearchResultsTooltip">
          <div className={styles['text']}>
            <UIText2 color="white_100">{text}</UIText2>
          </div>
          <Button size="XS" theme="fill_white_secondary" loading={loading} onClick={handleApply}>
            Применить
          </Button>
        </div>
      }
      open={!!open}
    />
  );

  return (
    <>
      {React.cloneElement(children, { ...children.props, ref: handleChildrenRef })}
      {hostElement ? ReactDOM.createPortal(tooltipElement, hostElement) : tooltipElement}
    </>
  );
};
